<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<div class="sf-col sf-col-12">
				<sf-card class="p-0 border-0 bg-transparent">
					<pc-pcm-tap-kd-graph ref="graph" :scrId="scrId"></pc-pcm-tap-kd-graph>
				</sf-card>
			</div>

			<div class="sf-col-5">
				<el-row :gutter="30">
					<el-col :span="12">
						<sf-card class="p-0 border-0 bg-transparent" height="320px">
							<pc-pcm-tap-kd-table-1 class="p-0 border-0 bg-transparent" ref="table" :scrId="scrId"></pc-pcm-tap-kd-table-1>
						</sf-card>
					</el-col>
					<el-col :span="12">
						<sf-card class="p-0 border-0 bg-transparent" height="320px">
							<pc-pcm-tap-kd-table-2 class="p-0 border-0 bg-transparent" ref="table" :scrId="scrId"></pc-pcm-tap-kd-table-2>
						</sf-card>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import PcPcmTapKdGraph from './PcPcmTapKdGraph.vue';
import PcPcmTapKdTable1 from './PcPcmTapKdTable1.vue';
import PcPcmTapKdTable2 from './PcPcmTapKdTable2.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {},
	components: { PcPcmTapKdGraph, PcPcmTapKdTable1, PcPcmTapKdTable2 },
	methods: {}
};
</script>

<style></style>
